import { formatPhoneNumberHref } from './phoneNumberHelper';

export const getImageIndex = (length, index) => {
  if (index < 0) {
    return length;
  }

  return index;
};

/** Dispatch event on click outside of node */
export const clickOutside = node => {
  const handleClick = event => {
    if (node && !node.contains(event.target) && !event.defaultPrevented) {
      node.dispatchEvent(new CustomEvent('click_outside', node));
    }
  };

  try {
    document.addEventListener('click', handleClick, true);
  } catch (e) {}

  return {
    destroy() {
      try {
        document.removeEventListener('click', handleClick, true);
      } catch (e) {}
    },
  };
};

export const getBackgroundImage = (properties, innerWidth) => {
  const backgroundLeft = `--background-image: linear-gradient(189deg, transparent, hsla(0, 0%, 100%, 0) 85%, ${properties?.backgroundColor} 0), url(${properties?.backgroundHeroImage})`;
  const backgroundRight = `--background-image: linear-gradient(170deg, transparent, hsla(0, 0%, 100%, 0) 85%, ${properties?.backgroundColor} 0), url(${properties?.backgroundHeroImage})`;
  const background = `--background-image: linear-gradient(0deg, transparent, hsla(0, 0%, 0%, 0) 100%, ${properties?.backgroundColor} 0), url(${properties?.backgroundHeroImage})`;

  if (properties?.imageAlignment === 'right') {
    return backgroundRight;
  } else if (innerWidth <= 1124) {
    return background;
  } else {
    return backgroundLeft;
  }
};

export const getWrapperStyles = () => {
  return `max-width:1300px;margin:0 auto;box-sizing:border-box;`;
};
export const getTextColor = (backgroundColor: string) => {
  var color: string | null = null;

  if (typeof backgroundColor == 'string')
    color = getContrastColor(backgroundColor);

  return color;
};

function getContrastColor(bgColor) {
  if (!bgColor) return '#0E0F11'; // default to black if no color is passed
  if (bgColor.startsWith('rgba')) {
    // if color is in rgba format, parse the alpha value
    const alpha = parseFloat(bgColor.match(/rgba\(.*,\s*([\d.]+)\)/)[1]);
    if (alpha < 0.5) return 'white'; // if background is transparent, default to white
    bgColor = bgColor.replace(/rgba\(([\d,.\s]+)\)\s*[\d.]+/, (_, nums) => {
      // convert rgba to hex
      return (
        '#' +
        nums
          .split(',')
          .map(num => parseInt(num).toString(16).padStart(2, '0'))
          .join('')
      );
    });
  }
  if (bgColor.startsWith('#')) {
    // if color is in hex format, parse the RGB values
    const hex = bgColor.replace('#', '');
    const [r, g, b] =
      hex.length === 3
        ? hex.split('').map(c => parseInt(c + c, 16)) // handle short hex format
        : hex.match(/.{2}/g).map(c => parseInt(c, 16)); // handle long hex format
    const brightness = (r * 299 + g * 587 + b * 114) / 1000; // calculate brightness according to W3C formula
    return brightness > 128 ? '#0E0F11' : 'white'; // if brightness is above threshold, return black, otherwise return white
  }
  return '#0E0F11'; // default to black if color is not in hex or rgba format
}

export const getBillingType = (
  type: 'Hourly' | 'Daily' | 'Weekly' | 'Bi-Weekly' | 'Monthly',
) => {
  switch (type) {
    case 'Hourly':
      return 'per hour';
    case 'Daily':
      return 'day';
    case 'Weekly':
      return 'week';
    case 'Bi-Weekly':
      return 'bi-weekly';
    case 'Monthly':
      return 'month';
    default:
      return '';
  }
};

export function getHref(
  type: 'Phone' | 'Email' | 'External' | 'Section' | 'SMS',
  value: string,
) {
  if (type === 'Phone') {
    return `tel:${formatPhoneNumberHref(value)}`;
  } else if (type === 'SMS') {
    return `sms:${formatPhoneNumberHref(value)}`;
  } else if (type === 'Email') {
    return `mailto:${value}`;
  } else if (type === 'External') {
    // if the external url does not start with http or https, add https
    if (!value?.startsWith('http')) {
      return `https://${value}`;
    }
    return `${value}`;
  } else if (type === 'Section') {
    return value ? `#${value}` : '#form';
  } else {
    return '#form';
  }
}
